import { ParameterTypeEnum, type StrategyLike } from './OrderStrategy.types';
import { PresenceEnum } from './types';

export const ManualStrategy: StrategyLike = {
  Name: 'Manual',
  Group: 'All',
  Parameters: [
    {
      Name: 'LimitPrice',
      Type: ParameterTypeEnum.Price,
      Presence: PresenceEnum.Required,
      Description: 'Limit Price for the order.',
      DisplayName: 'Limit Price',
    },
  ],
  Description: 'Manual order',
  DisplayName: 'Manual',
};
